import INFTCollections from '../../models/INFTCollections'
import SnowBallCard from '../../nftFormats/SnowBall/Card/SnowBallCard'
import SnowBallDetail from '../../nftFormats/SnowBall/Detail/SnowBallDetail'
import SnowBallActivtyDetail from '../../nftFormats/SnowBall/Activity/SnowBallActivtyDetail'

import SnowballNFTEarlyVoterLogo from '../../../../assets/nft-logo/SnowballNFTEarlyVoter.gif'
import SnowballNFTCovidReliefLogo from '../../../../assets/nft-logo/SnowballNFTCovidRelief.gif'
import SnowballNFTSnowBallHeadLogo from '../../../../assets/nft-logo/SnowballNFTSnowBallHead.png'
import SnowballNFTRollingPinkLogo from '../../../../assets/nft-logo/SnowballNFTRollingPink.gif'
import SnowballNFTRollingPurpleLogo from '../../../../assets/nft-logo/SnowballNFTRollingPurple.gif'
import SnowballNFTRollingOrangeLogo from '../../../../assets/nft-logo/SnowballNFTRollingOrange.gif'
import SnowballNFTRollingBlueLogo from '../../../../assets/nft-logo/SnowballNFTRollingBlue.gif'
import SnowballNFTRollingGreenLogo from '../../../../assets/nft-logo/SnowballNFTRollingGreen.gif'
import SnowballNFTRollingSasquatchLogo from '../../../../assets/nft-logo/SnowballNFTRollingSasquatch.gif'
//import SnowballNFTSherpaIDOLogo from '../../../../assets/nft-logo/SnowballNFTSherpaIDO.gif'

const social = {
  website: 'https://beta.snowball.network/nft-marketplace',
  twitter: 'snowballdefi',
  telegram: 'https://t.me/throwsnowballs',
  discord: 'https://discord.com/invite/BGpEHvehMz'
}

export const SnowBallData: INFTCollections[] = [
  {
    id: 'SnowballNFTEarlyVoter',
    tokenAddress: '0x7b097a18738ca9fd524384dab74c57cb12dac724',
    name: 'Snowball Early Voter',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTEarlyVoterLogo,
    ...social
  },
  {
    id: 'SnowballNFTCovidRelief',
    tokenAddress: '0xd928ab4b54f7fd0498160ee52ac0c92bbb9c9cb3',
    name: 'Snowball NFT Covid Relief',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTCovidReliefLogo,
    ...social
  },
  {
    id: 'SnowballNFTSnowBallHead',
    tokenAddress: '0x6a81866c94efc097e75abcbcddd3e8b63ebebe93',
    name: 'SnowBall Head',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTSnowBallHeadLogo,
    ...social
  },
  {
    id: 'SnowballNFTRollingPink',
    tokenAddress: '0x35f268dac74f94785135aa134dedef7e67db8fe3',
    name: 'Snowball Rolling Sasquatch - Pink',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTRollingPinkLogo,
    ...social
  },
  {
    id: 'SnowballNFTRollingPurple',
    tokenAddress: '0xb954ae9a4374751cb3d578cfa3db96e0e5881c00',
    name: 'Snowball Rolling Sasquatch - Purpl',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTRollingPurpleLogo,
    ...social
  },
  {
    id: 'SnowballNFTRollingOrange',
    tokenAddress: '0xd65e006644d417af6a9385182c21733762b94e83',
    name: 'Snowball Rolling Sasquatch - Orange',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTRollingOrangeLogo,
    ...social
  },
  {
    id: 'SnowballNFTRollingBlue',
    tokenAddress: '0xae88be7d3fe6545c688b640b427af4bab90e2638',
    name: 'Snowball Rolling Sasquatch - Blue',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTRollingBlueLogo,
    ...social
  },
  {
    id: 'SnowballNFTRollingGreen',
    tokenAddress: '0x5edd9bc699b6a613875e6760b4978d14d6eb3899',
    name: 'Snowball Rolling Sasquatch - Green',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTRollingGreenLogo,
    ...social
  },
  {
    id: 'SnowballNFTRollingSasquatch',
    tokenAddress: '0xd66df640a2f213b6e5087204caee2b2145a1c1c9',
    name: 'Snowball Rolling Sasquatch - Laser Eyes',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTRollingSasquatchLogo,
    ...social
  },
  /*{
    id: 'SnowballNFTSherpaIDO',
    tokenAddress: '0x1b60d88cb3db98a02594a85d0f823ac08194100f',
    name: 'Sherpa Cash NFT - Climb to the Top',
    cardFormat: SnowBallCard,
    detailFormat: SnowBallDetail,
    activityFormat: SnowBallActivtyDetail,
    category: 1,
    creatorAddress: '0x3B7631F8E3428dEaB77634BF799b622ce412e9Ea',
    logo: SnowballNFTSherpaIDOLogo,
    ...social
  }*/
]

export const SnowBallCategoryData = {
  [SnowBallData[0].tokenAddress.toLowerCase()]: SnowBallData[0].category,
  [SnowBallData[1].tokenAddress.toLowerCase()]: SnowBallData[1].category,
  [SnowBallData[2].tokenAddress.toLowerCase()]: SnowBallData[2].category,
  [SnowBallData[3].tokenAddress.toLowerCase()]: SnowBallData[3].category,
  [SnowBallData[4].tokenAddress.toLowerCase()]: SnowBallData[4].category,
  [SnowBallData[5].tokenAddress.toLowerCase()]: SnowBallData[5].category,
  [SnowBallData[6].tokenAddress.toLowerCase()]: SnowBallData[6].category,
  [SnowBallData[7].tokenAddress.toLowerCase()]: SnowBallData[7].category,
  [SnowBallData[8].tokenAddress.toLowerCase()]: SnowBallData[8].category,
  //[SnowBallData[9].tokenAddress.toLowerCase()]: SnowBallData[9].category
}

export const SnowBallNFTJson: { [key: string]: string } = {
  SnowballNFTEarlyVoter: 'early_voter.json',
  SnowballNFTRollingBlue: 'rolling_blue.json',
  SnowballNFTRollingGreen: 'rolling_green.json',
  SnowballNFTRollingPurple: 'rolling_purple.json',
  SnowballNFTRollingPink: 'rolling_pink.json',
  SnowballNFTRollingOrange: 'rolling_orange.json',
  SnowballNFTRollingSasquatch: 'rolling_laser.json'
}
